<!-- <div *ngIf="!isLoading && !showUpdate && !showNouser"
  class="w-full max-w-xl mx-auto bg-white p-8 text-center border-b border-[#ffffef]">
  <div class="mb-6">
    <a href="#">
      <img src="https://imagefarmax.s3.us-east-1.amazonaws.com/Inphago.png" alt="Logo Inphapro"
        class="mx-auto max-w-[350px] h-auto">
    </a>
  </div>

  <h1 class="text-[26px] leading-10 font-bold tracking-tight text-[#181F38] text-center">Validación de Datos del
    Paciente</h1>

  <p class="text-base leading-6 text-[#181F38] text-justify my-5">
    Por favor, valide y actualice la siguiente información personal. Solo algunos campos están habilitados para edición.
  </p>

  <form [formGroup]="infoForm" class="text-left bg-[#f4f4f4] p-6 rounded-lg">
    <div *ngFor="let field of campos">
      <label [for]="field.id" class="block mt-4 font-semibold text-[#181F38]">{{ field.label }}</label>
      <input [type]="field.type" [id]="field.id" [formControlName]="field.id" [placeholder]="field.placeholder"
        [disabled]="field.disabled"
        class="w-full px-3 py-2 mt-1 border border-gray-300 rounded focus:outline-none font-[Poppins]" />
    </div>

    <mat-form-field class="w-full mt-4">
      <mat-label>Aceptar o Rechazar Medicamento</mat-label>
      <mat-select formControlName="rechazo">
        <mat-option *ngFor="let option of listRechazar" [value]="option.id">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>


       <mat-form-field class="w-full mt-4">
            <mat-label>Comentario Rechazo</mat-label>

      <input matInput formControlName="comentarioRechazo" type="text" />
    </mat-form-field>

    <button *ngIf="!isFormModified && dataUser.notificacion == '1'" (click)="onSubmit(1)" type="submit"
      class="mt-6 py-3 px-6 bg-[#181F38] text-white rounded w-full hover:bg-[#2c3360]">
      Enviar datos
    </button>

    <button *ngIf="isFormModified && dataUser.notificacion == '1'" (click)="onSubmit(0)" type="submit"
      class="mt-6 py-3 px-6 bg-[#181F38] text-white rounded w-full hover:bg-[#2c3360]">
      Enviar datos
    </button>
  </form>

</div>

<section *ngIf="showUpdate" class="w-[45%] flex flex-col mx-auto p-8 rounded-2xl bg-color_box  py-8 my-8">
  <img class="w-[65%] m-auto rounded-2xl" src="https://imagefarmax.s3.us-east-1.amazonaws.com/Inphago.png" alt="Logo">
  <h1 class="text-center my-2"> Hemos recibido la información que requiere actualización y notificaremos al departamento
    correspondiente para su gestión. En un plazo máximo de 24 horas le estaremos brindando una respuesta.</h1>
</section>

<section *ngIf="showNouser" class="w-[45%] flex flex-col mx-auto p-8 rounded-2xl bg-color_box  py-8 my-8">
  <img class="w-[65%] m-auto rounded-2xl" src="https://imagefarmax.s3.us-east-1.amazonaws.com/Inphago.png" alt="Logo">
  <h1 class="text-center my-2"> Paciente no identificado. No se encontró un registro que coincida con los datos
    proporcionados.
  </h1>
</section>

<app-loading *ngIf="isLoading"></app-loading> -->

<div *ngIf="!isLoading && !showUpdate && !showNouser"
  class="w-full max-w-xl mx-auto bg-white p-8 text-center border border-gray-100 rounded-2xl shadow-sm">

  <div class="mb-6">
    <a href="#">
      <img src="https://imagefarmax.s3.us-east-1.amazonaws.com/Inphago.png" alt="Logo Inphapro"
        class="mx-auto w-[35%] max-w-[300px] h-auto">
    </a>
  </div>

  <h1 class="text-[26px] leading-10 font-bold tracking-tight text-[#181F38]">
    Validación de Datos del Paciente
  </h1>

  <p class="text-base leading-6 text-[#181F38] text-justify my-5">
    Por favor, valide y actualice la siguiente información personal. Solo algunos campos están habilitados para edición.
  </p>

  <!-- <form [formGroup]="infoForm" class="text-left bg-[#f9f9f9] p-6 rounded-2xl shadow-inner border border-gray-200">
    <div *ngFor="let field of campos">
      <label [for]="field.id" class="block mt-4 font-semibold text-[#181F38]">{{ field.label }}</label>
      <input [type]="field.type"
             [id]="field.id"
             [formControlName]="field.id"
             [placeholder]="field.placeholder"
             [disabled]="field.disabled"
             class="w-full px-4 py-2 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#181F38] font-[Poppins] transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500" />
    </div>

    <div class="mt-6">
      <label for="rechazo" class="block font-semibold text-[#181F38]">Aceptar o Rechazar Medicamento</label>
      <select id="rechazo"
              formControlName="rechazo"
              class="w-full px-4 py-2 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#181F38] font-[Poppins] transition-all duration-200 bg-white">
        <option *ngFor="let option of listRechazar" [value]="option.id">{{ option.label }}</option>
      </select>
    </div>

    <div class="mt-6">
      <label for="comentarioRechazo" class="block font-semibold text-[#181F38]">Comentario Rechazo</label>
      <input id="comentarioRechazo"
             type="text"
             formControlName="comentarioRechazo"
             placeholder="Escriba su comentario..."
             class="w-full px-4 py-2 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#181F38] font-[Poppins] transition-all duration-200" />
    </div>

    <button *ngIf="dataUser.notificacion == '1'" 
            (click)="onSubmit(isFormModified ? 0 : 1)"
            type="submit"
            class="mt-8 py-3 px-6 bg-[#181F38] text-white rounded-lg w-full font-semibold hover:bg-[#2c3360] transition-all duration-200 shadow-md">
      Enviar datos
    </button>
  </form> -->
  <form [formGroup]="infoForm" class="text-left bg-[#f9f9f9] p-6 rounded-2xl shadow-inner border border-gray-200">
    <div *ngFor="let field of campos">
      <ng-container *ngIf="field.id !== 'municipio'; else municipioSelect">
        <label [for]="field.id" class="block mt-4 font-semibold text-[#181F38]">{{ field.label }}</label>
        <input [type]="field.type" [id]="field.id" [formControlName]="field.id" [placeholder]="field.placeholder"
          [disabled]="field.disabled"
          class="w-full px-4 py-2 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#181F38] font-[Poppins] transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500" />
      </ng-container>
    </div>

    <!-- Campo MUNICIPIO personalizado -->
    <ng-template #municipioSelect>
      <div class="mt-6">
        <mat-form-field class="w-full">
          <mat-label>Municipio</mat-label>
          <mat-select formControlName="municipio">
            <mat-option>
              <mat-form-field class="w-full">
                <input appTrimInput matInput placeholder="Buscar ciudad..." (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()" [formControl]="tipoDocSearchControlNac" />
              </mat-form-field>
            </mat-option>
            <mat-option *ngFor="let city of filteredCitiesNac" [value]="city.cod">
              {{ city.ciudad }} | {{ city.departamento }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-template>

    <!-- Select de aceptación o rechazo -->
    <div class="mt-6">
      <label for="rechazo" class="block font-semibold text-[#181F38]">Aceptar o Rechazar Medicamento</label>
      <select id="rechazo" formControlName="rechazo"
        class="w-full px-4 py-2 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#181F38] font-[Poppins] transition-all duration-200 bg-white">
        <option *ngFor="let option of listRechazar" [value]="option.id">{{ option.label }}</option>
      </select>
    </div>

    <!-- Comentario -->
    <div class="mt-6">
      <label for="comentarioRechazo" class="block font-semibold text-[#181F38]">Comentario Rechazo</label>
      <input id="comentarioRechazo" type="text" formControlName="comentarioRechazo"
        placeholder="Escriba su comentario..."
        class="w-full px-4 py-2 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#181F38] font-[Poppins] transition-all duration-200" />
    </div>

    <!-- Botón -->
    <!-- <button *ngIf="dataUser.notificacion == '1'" (click)="onSubmit(isFormModified ? 0 : 1)" type="submit"
      class="mt-8 py-3 px-6 bg-[#181F38] text-white rounded-lg w-full font-semibold hover:bg-[#2c3360] transition-all duration-200 shadow-md">
      Enviar datos
    </button> -->
    <button *ngIf="dataUser.notificacion == '1'" (click)="onSubmit(isFormModified ? 0 : 1)"
      [disabled]="infoForm.invalid" class="mt-8 py-3 px-6 rounded-lg w-full font-semibold transition-all duration-200 shadow-md
         bg-[#181F38] text-white
         disabled:bg-gray-300 disabled:cursor-not-allowed disabled:text-gray-600">
      Enviar datos
    </button>

  </form>

</div>

<section *ngIf="showUpdate"
  class="w-[45%] flex flex-col mx-auto p-8 rounded-2xl bg-white border border-gray-200 shadow-sm text-center my-10">
  <img class="w-[65%] mx-auto rounded-2xl mb-4" src="https://imagefarmax.s3.us-east-1.amazonaws.com/Inphago.png"
    alt="Logo">
  <h1 class="text-[#181F38] font-medium leading-relaxed">
    Hemos recibido la información que requiere actualización y notificaremos al departamento correspondiente para su
    gestión.
    En un plazo máximo de 24 horas le estaremos brindando una respuesta.
  </h1>
</section>

<section *ngIf="showNouser"
  class="w-[45%] flex flex-col mx-auto p-8 rounded-2xl bg-white border border-gray-200 shadow-sm text-center my-10">
  <img class="w-[65%] mx-auto rounded-2xl mb-4" src="https://imagefarmax.s3.us-east-1.amazonaws.com/Inphago.png"
    alt="Logo">
  <h1 class="text-[#181F38] font-medium leading-relaxed">
    Paciente no identificado. No se encontró un registro que coincida con los datos proporcionados.
  </h1>
</section>

<app-loading *ngIf="isLoading"></app-loading>